import React, { useCallback, useEffect, useRef, useState } from 'react';
import MaskedInput from 'react-text-mask';
import { useField } from '@unform/core';

import { Input as InputBase } from '~/components';

interface InputCpfCnpjMaskProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'name'> {
  name: string;
  formRef: React.RefObject<any>;
  onChangeNumerico?: (numbers: string) => void; // <- Aqui
}

const cpfMask = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];
const cnpjMask = [
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];

function onlyNumbers(str: string): string {
  return str.replace(/\D/g, '');
}

const InputCpfCnpjMask: React.FC<InputCpfCnpjMaskProps> = ({
  name,
  formRef,
  onChangeNumerico,
  ...rest
}): JSX.Element => {
  const inputElementRef = useRef<HTMLInputElement>(null);
  const { fieldName, defaultValue = '', registerField } = useField(name);
  const [value, setValue] = useState<string>(defaultValue as string);

  // Máscara dinâmica baseada na quantidade de dígitos numéricos
  const maskFunction = (rawValue: string): (RegExp | string)[] => {
    const numbers = onlyNumbers(rawValue);
    return numbers.length > 11 ? cnpjMask : cpfMask;
  };

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputElementRef.current,
      getValue: (ref) => (ref ? ref.value : ''),
      setValue: (ref, v) => setValue(typeof v === 'string' ? v : ''),
      clearValue: () => setValue(''),
    });
    // eslint-disable-next-line
  }, [fieldName, registerField]);

  // Permite até 19 caracteres (CNPJ com máscara completa tem 18, mas com digitação pode passar)
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const v = e.target.value;
      if (v.length > 19) return;
      setValue(v);
      if (onChangeNumerico) {
        onChangeNumerico(onlyNumbers(v));
      }
    },
    [onChangeNumerico],
  );

  return (
    <MaskedInput
      mask={maskFunction}
      value={value}
      onChange={handleChange}
      name={name}
      placeholder="CPF ou CNPJ"
      render={(ref, props) => (
        <InputBase
          {...props}
          ref={(instance) => {
            if (typeof ref === 'function' && instance !== null) ref(instance);
            (
              inputElementRef as React.MutableRefObject<HTMLInputElement | null>
            ).current = instance;
          }}
        />
      )}
      {...rest}
    />
  );
};

export default InputCpfCnpjMask;
